/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Grid, Typography, Container, Link } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';
import { withTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import i18n from '../../i18n';

const useStyles = makeStyles(theme => ({
  filterUser: {
    minHeight: '80px',
  },
  main: {
    display: 'flex',
    alignItems: 'center',
  },
  daysRemmain: {
    fontSize: '9px',
  },
  accountName: {
    fontWeight: '600',
    marginRight: '10px',
  },
  remainingDays: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#E74C3C',
  },
}));

function FilterUser(props) {
  const [isSearchDone, setIsSearchDone] = useState(false);
  const history = useNavigate();
  const classes = useStyles();
  const { freezePeriod } = props;
  const handleSearch = () => {
    setIsSearchDone(!isSearchDone);
  };

  return (
    <Grid container item className={`${classes.filterUser} filter-wrapper`}>
      <span className={classes.daysRemmain}>{i18n.t('placeOrder.filterUser.daysRemaining')}: </span>
      <span className={classes.remainingDays}>
        {freezePeriod}
        {freezePeriod !== 'Freeze' ? ` ${i18n.t('placeOrder.filterUser.days')}` : ''}
      </span>
    </Grid>
  );
}

export default (withTranslation()(FilterUser));
